import { render, staticRenderFns } from "./FavoritesModal.vue?vue&type=template&id=50e6129e&scoped=true&"
import script from "./FavoritesModal.vue?vue&type=script&lang=ts&"
export * from "./FavoritesModal.vue?vue&type=script&lang=ts&"
import style0 from "./FavoritesModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FavoritesModal.vue?vue&type=style&index=1&id=50e6129e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6129e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e6129e')) {
      api.createRecord('50e6129e', component.options)
    } else {
      api.reload('50e6129e', component.options)
    }
    module.hot.accept("./FavoritesModal.vue?vue&type=template&id=50e6129e&scoped=true&", function () {
      api.rerender('50e6129e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Favorites/FavoritesModal.vue"
export default component.exports